import { proxyCustomElement, HTMLElement, createEvent, h, Host } from '@stencil/core/internal/client';
import { d as defineCustomElement$3 } from './custom-popper2.js';
import { d as defineCustomElement$2 } from './form-control-error-text2.js';
import { d as defineCustomElement$1 } from './form-control-tooltip2.js';

const SelectInput = /*@__PURE__*/ proxyCustomElement(class SelectInput extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.formControlInput = createEvent(this, "formControlInput", 7);
        this.formControlBlur = createEvent(this, "formControlBlur", 7);
        this.handleFormControlInput = (event) => {
            const target = event.target;
            const name = target.getAttribute('name');
            this.inputHandler(name, target.value);
            this.formControlInput.emit(target.value);
        };
        this.updateInput = (newValue) => {
            this.selectElement.value = newValue;
        };
        this.name = undefined;
        this.label = undefined;
        this.options = undefined;
        this.inputHandler = undefined;
        this.defaultValue = undefined;
        this.helpText = undefined;
        this.errorText = undefined;
        this.disabled = undefined;
    }
    handleDefaultValueChange(newValue) {
        this.updateInput(newValue);
    }
    componentDidLoad() {
        this.updateInput(this.defaultValue);
    }
    render() {
        var _a;
        return (h(Host, { key: '2825653443c2fdd8c6e059e03f9170fa0f293fe5', exportparts: "label,input,input-invalid" }, h("div", { key: '8eb3d38a99762d030b534cbb195e5f12da754ed4', class: "form-group d-flex flex-column" }, h("div", { key: 'ac41bf1269b5eec07e63eb9426d05684dac1aadc', class: "d-flex align-items-start gap-2" }, h("label", { key: 'ba1cd374fdb460b72ed509366a469c6d0cf9779e', part: "label", class: "form-label", htmlFor: this.name }, this.label), h("form-control-tooltip", { key: '7e81054e6daa2b19cae341126d49085d9c083602', helpText: this.helpText })), h("select", { key: '8eea54929eddbc98e71c0d8175e54b7e284a9f63', ref: el => (this.selectElement = el), id: this.name, name: this.name, onBlur: this.formControlBlur.emit, onInput: this.handleFormControlInput, part: `input ${this.errorText ? 'input-invalid' : ''}`, class: this.errorText ? 'form-select is-invalid' : 'form-select', disabled: this.disabled }, (_a = this.options) === null || _a === void 0 ? void 0 : _a.map(option => (h("option", { value: option.value }, option.label)))), h("form-control-error-text", { key: 'e980065897e2c26b3f787dc576d4c5ffaeb7bdd3', errorText: this.errorText, name: this.name }))));
    }
    static get watchers() { return {
        "defaultValue": ["handleDefaultValueChange"]
    }; }
}, [0, "form-control-select", {
        "name": [8],
        "label": [1],
        "options": [16],
        "inputHandler": [16],
        "defaultValue": [1, "default-value"],
        "helpText": [1, "help-text"],
        "errorText": [1, "error-text"],
        "disabled": [4]
    }, undefined, {
        "defaultValue": ["handleDefaultValueChange"]
    }]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["form-control-select", "custom-popper", "form-control-error-text", "form-control-tooltip"];
    components.forEach(tagName => { switch (tagName) {
        case "form-control-select":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, SelectInput);
            }
            break;
        case "custom-popper":
            if (!customElements.get(tagName)) {
                defineCustomElement$3();
            }
            break;
        case "form-control-error-text":
            if (!customElements.get(tagName)) {
                defineCustomElement$2();
            }
            break;
        case "form-control-tooltip":
            if (!customElements.get(tagName)) {
                defineCustomElement$1();
            }
            break;
    } });
}
defineCustomElement();

export { SelectInput as S, defineCustomElement as d };
